module.exports = __webpack_public_path__ + "static/bbis-underfloor-heating-min-8149c8a65b90e99a98f6ace8c6c4e980.jpg";